import { useAtomValue } from "jotai";

import { isAlreadyPaidAtom } from "@/screens/BookingDetail/NewPatronBookingFlow/components/EditBooking/atoms/selectors/isAlreadyPaidAtom/isAlreadyPaidAtom";
import { currentSessionUserClientIdAtom } from "@/screens/BookingDetail/NewPatronBookingFlow/components/EditBooking/atoms/stores";

import { currentUserIsBookingOwnerAtom } from "../../../../../../../../../atoms/selectors/currentUserIsBookingOwnerAtom/currentUserIsBookingOwnerAtom";
import { getRoundFromIdAtom } from "../../../../../../../../../atoms/selectors/getRoundFromIdAtom/getRoundFromIdAtom";

export const useShouldShowRemoveRoundMenuItem = (roundId: string) => {
  const round = useAtomValue(getRoundFromIdAtom(roundId));
  const currentSessionUserClientId = useAtomValue(
    currentSessionUserClientIdAtom
  );
  const roundIsOwner = !!round?.isOwner;
  const roundPlayerClientId = round?.player.id;

  const isCurrentUserRound =
    !!roundPlayerClientId &&
    !!currentSessionUserClientId &&
    roundPlayerClientId === currentSessionUserClientId;

  const currentUserIsOwner = useAtomValue(currentUserIsBookingOwnerAtom);
  const shouldShowMenuOption = !roundIsOwner && currentUserIsOwner;

  const isAlreadyPaid = useAtomValue(isAlreadyPaidAtom);

  return (
    (shouldShowMenuOption && !isAlreadyPaid) ||
    (isCurrentUserRound && !isAlreadyPaid) ||
    (!currentUserIsOwner && !roundIsOwner && !isAlreadyPaid)
  );
};
